import type { FileIconProps } from './FileIcon';

function FolderIcon({ size = 28 }: FileIconProps) {
  return (
    <svg
      width={size}
      height={size * 1.25}
      viewBox='0 0 28 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='icon-folder'>
      <path
        d='M28 5.39482C28 4.47434 27.1643 3.72815 26.1334 3.72815L22.4001 3.72815L22.4001 33.7281L23.3334 33.7281C24.8798 33.7281 26.1334 32.6089 26.1334 31.2281L26.1334 10.8115C27.1643 10.8115 28 10.0653 28 9.14481L28 5.39482Z'
        fill='#AD6A06'
      />
      <rect
        opacity='0.7'
        x='24.2664'
        y='6.22717'
        width='25'
        height='16.7997'
        rx='2'
        transform='rotate(90 24.2664 6.22717)'
        fill='#EDE3DC'
      />
      <path
        d='M20.3703 1.23468C21.4613 1.1487 22.3997 1.92317 22.3997 2.90955L22.3997 34.5467C22.3997 35.5331 21.4613 36.3076 20.3703 36.2216L2.55598 34.8176C1.10973 34.7037 9.58592e-05 33.6129 9.59164e-05 32.3053L9.71033e-05 5.15096C9.71605e-05 3.84335 1.10973 2.75263 2.55598 2.63865L20.3703 1.23468Z'
        fill='#CB8D30'
      />
      <path
        d='M20.3703 1.23468C21.4613 1.1487 22.3997 1.92317 22.3997 2.90955L22.3997 34.5467C22.3997 35.5331 21.4613 36.3076 20.3703 36.2216L2.55598 34.8176C1.10973 34.7037 9.58592e-05 33.6129 9.59164e-05 32.3053L9.71033e-05 5.15096C9.71605e-05 3.84335 1.10973 2.75263 2.55598 2.63865L20.3703 1.23468Z'
        fill='url(#paint0_linear_8689_67632)'
        fillOpacity='0.25'
      />
      <path
        d='M9.09091 13.9996H17.0909M12 16.6663H20M6.90909 19.333H14.9091M4 21.9996H12'
        stroke='white'
        strokeOpacity='0.6'
        strokeWidth='2'
      />
      <defs>
        <linearGradient
          id='paint0_linear_8689_67632'
          x1='16.4264'
          y1='20.6066'
          x2='16.4264'
          y2='36.095'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#7F510B' stopOpacity='0' />
          <stop offset='1' stopColor='#7F510B' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default FolderIcon;
